import { makeHumanReadable } from "./makeHumanReadable";

export const enumToOptions = <T extends object>(
  enumObj: T,
  MakeHumanReadable = false,
): {
  label: string;
  value: T[keyof T];
}[] =>
  Object.values(enumObj)
    .map((x) => {
      const label: string = MakeHumanReadable ? makeHumanReadable(x) : x;
      return {
        label: label,
        value: x,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
